import { useRef, useState } from "react";

import { PlayIcon } from "@/components/Icons/PlayIcon";
import type { InputFile } from "@/components/VideoInput/useVideoInput";

import { formatVideoDuration } from "./helpers";

interface CommunityPostVideoForAppPreviewProps {
  video: InputFile;
}
export function CommunityPostVideoForAppPreview({ video }: CommunityPostVideoForAppPreviewProps): React.ReactNode {
  const [duration, setDuration] = useState(0);
  const refVideo = useRef<HTMLVideoElement | null>(null);
  const onLoadedMetadata = () => {
    if (refVideo.current) {
      setDuration(refVideo.current.duration);
    }
  };

  return (
    <figure className="relative max-h-media-display-compact w-full cursor-pointer overflow-hidden rounded-md bg-background-default-inverse/20 @md:max-h-media-display-wide @md:w-auto">
      <div className="absolute inset-0 z-10 flex items-center justify-center bg-background-default-inverse/20">
        <span className="flex size-control-md items-center justify-center rounded-full bg-background-default-inverse transition-colors hover:bg-background-default-inverse/90">
          <span className="ml-0.5 fill-text-default-inverse">
            <PlayIcon size={20} />
          </span>
        </span>
        <span className="absolute right-2 bottom-2 rounded-lg bg-background-default-inverse px-space-sm py-space-xs text-caption text-text-default-inverse">
          {formatVideoDuration(duration)}
        </span>
      </div>

      <video
        ref={refVideo}
        className="max-h-full max-w-full object-contain"
        src={video.url}
        preload="metadata"
        {...{
          onLoadedMetadata,
        }}
      />
    </figure>
  );
}
